declare global {
  interface Window {
    clarity?: (action: string, key: string, value: string) => void;
  }
}

export function setClarityTag(key: string, value: string) {
  if (typeof window !== "undefined" && window.clarity) {
    window.clarity("set", key, value);
  }
}
